<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { relativeMessageStamp } from 'shared/helpers/timeHelper';
import { useLocale } from 'shared/composables/useLocale';
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';

const { t } = useI18n();
const { resolvedLocale } = useLocale();
const { content, createdAt } = useMessageContext();

const readableTime = computed(() =>
  relativeMessageStamp(createdAt.value, t, resolvedLocale.value)
);
</script>

<template>
  <BaseBubble
    v-tooltip.top="readableTime"
    class="px-3 py-1 !rounded-2xl flex min-w-0 items-center gap-2"
    data-bubble-name="activity"
  >
    <span v-dompurify-html="content" :title="content" />
  </BaseBubble>
</template>
